import type { MediaInfoDimensions } from './mediaInfoDimensions';
import type { MediaInfoType } from './mediaInfoType';

export interface MediaInfo {
  dimensions?: MediaInfoDimensions;
  id: string;
  mimeType?: string;
  size?: number;
  thumbnailUrl?: string;
  type: MediaInfoType;
  url: string;
}
